import $ from "jquery";

$(document).ready(function() {
    // Select all elements with the .single-tab class
    const $singleTabs = $('.single-tab');
    console.log('Single tabs found:', $singleTabs);

    // Cache the container that will be animated
    const $tabContentContainer = $('.tab_content_con');

    /**
     * Updates the container's height to match the currently active tab's content.
     */
    function updateTabContentHeight() {
        const $activeTabContent = $('.activetab');
        if ($activeTabContent.length) {
            const newHeight = $activeTabContent.outerHeight();
            console.log('Animating container to new height:', newHeight);

            // Animate from the old height to the new height
            $tabContentContainer.stop().animate(
                { height: newHeight },
                300
            );
        }
    }

    // On page load, update the container height to match any currently .activetab element
    updateTabContentHeight();

    $singleTabs.on('click', function() {
        const $tab = $(this);
        console.log('Tab clicked:', $tab);

        // If this tab is not already selected
        if (!$tab.hasClass('selected')) {
            console.log('Tab is not selected, proceeding to select it.');

            // Remove 'selected' from all .single-tab elements
            $singleTabs.removeClass('selected');
            console.log('Removed "selected" class from all tabs.');

            // Add 'selected' class to the clicked tab
            $tab.addClass('selected');
            console.log('Added "selected" class to the clicked tab:', $tab);

            // Get the data-tabid of the clicked tab
            const tabId = $tab.data('tabid');
            console.log('Data-tabid of clicked tab:', tabId);

            // Remove 'activetab' from all currently active elements
            $('.activetab').removeClass('activetab');

            // Find the corresponding element by the ID from data-tabid and add 'activetab'
            const $targetContent = $('.' + tabId);
            if ($targetContent.length) {
                $targetContent.addClass('activetab');
                console.log('Added "activetab" class to target content:', $targetContent);

                // After switching the active tab, animate the container to its new height
                updateTabContentHeight();
            } else {
                console.log('No target content found for tabId:', tabId);
            }
        } else {
            console.log('Tab is already selected, no action taken.');
        }
    });

    // Check if there is a 'tab' parameter in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');

    if (tabParam) {
        console.log('Tab parameter found in URL:', tabParam);

        // Construct the class name for the tab using the URL parameter
        const targetTabClass = 'tab-' + tabParam
        console.log('Looking for tab with class:', targetTabClass);

        // Find the tab element with the matching class
        const $targetTab = $singleTabs.filter(`.${targetTabClass}`);

        if ($targetTab.length) {
            console.log('Matching tab found:', $targetTab);

            // Simulate a click on the matching tab
            $targetTab.click();
        } else {
            console.log('No matching tab found for class:', targetTabClass);
        }
    } else {
        console.log('No tab parameter found in URL.');
    }
});